<div class="image-rotate">
  <div class="image-rotate-slider">
    <mat-icon svgIcon="rotate-left"
              (click)="rotate(-1)"></mat-icon>
    <input type="range" min="-180" [max]="180"
           (input)="rangeValueChanged($event)"
           (mouseup)="hideImageOverlay()"
           (mousedown)="showImageOverlay()"
           [value]="rangeValue" step="1">
    <mat-icon svgIcon="rotate-right"
              (click)="rotate(1)"></mat-icon>
  </div>
  <div class="image-rotate-buttons">
    <mat-icon svgIcon="rotate-left-90"
              (click)="decreaseRotateSnap()"></mat-icon>
    <mat-icon svgIcon="rotate-right-90"
              (click)="increaseRotateSnap()"></mat-icon>
  </div>
</div>
